import { put, takeEvery } from 'redux-saga/effects';
import { initialStateFactory, reducerFactory, sagasFactory } from 'utils/factories';
import actionsFactory from 'utils/factories/actions';
import { DEVICE_VERIFICATION_READING, FETCH_DEVICE_VERIFICATION, FULFILLED } from './actionTypes';

// actions
const actions = actionsFactory(DEVICE_VERIFICATION_READING);

export { actions };

// reducer
const initialState = initialStateFactory();
const reducer = reducerFactory(DEVICE_VERIFICATION_READING);
export default (state = initialState, action) => reducer(state, action);

// sagas
// the verification may have auto-concluded server side (DeviceVerification::Concludable)
function* refreshVerificationSaga({ payload }) {
    try {
        yield put({ type: FETCH_DEVICE_VERIFICATION, payload: payload.device_verification_id });
    } catch (error) {
        console.error(error);
    }
}

function* watchCreateFulfilled() {
    yield takeEvery(`CREATE_${DEVICE_VERIFICATION_READING}` + FULFILLED, refreshVerificationSaga);
}

const sagas = [...sagasFactory(DEVICE_VERIFICATION_READING, '/device_verification_readings'), watchCreateFulfilled];
export { sagas };
